export var SiblingTypes;
(function (SiblingTypes) {
    SiblingTypes["Previous"] = "previous";
    SiblingTypes["Next"] = "next";
})(SiblingTypes || (SiblingTypes = {}));
;
